<template>
  <p class="view-toggle">
    <span class="view-mode-title font-weight-bold">Visualizza: </span>
    <button class="btn btn-link px-1" :class="{ 'font-weight-bold' : viewMode === 'crediti' }" @click.prevent="$emit('update:viewMode', 'crediti')">Crediti</button>
    <button class="btn btn-link px-1" :class="{ 'font-weight-bold' : viewMode === 'debiti' }" @click.prevent="$emit('update:viewMode', 'debiti')">Debiti</button>
  </p>
</template>

<script>

export default {
  name: 'scadenzari-list-switcher',
  props: {
    viewMode: {
      type: String,
      required: true,
    },
  },
};

</script>

<style lang="scss">

.view-toggle {
  .view-mode-title {
    line-height: 1.5rem;
    vertical-align: middle;
  }
}

</style>
